import { UploadedFile } from "./uploaded-file.model";
import { UserComment } from "./user-comment.model";

export enum ComplaintLogStatus {
	Unresolved = 'unresolved',
	Resolved = 'resolved',
}

export interface ComplaintLog {
	id: string,
	customerId: string,
	title: string,
	notes: string,
	status: ComplaintLogStatus,
	createdOn: Date,
	createdById: string,
	uploadedFiles: UploadedFile[],
	comments: UserComment[],
}

export interface ComplaintLogProduct {
	id: string;
	complaintLogId: string;
	productId: string;
	quantity: number | null;
	notes: string;
}

export interface MappingComplaintLogToQualityAlert {
	id: string,
	complaintLogId: string,
	qualityAlertId: string,
}

export interface MappingComplaintLogToContact {
	id: string,
	complaintLogId: string,
	contactId: string,
}
